import React from "react";
import Header from "../Component/Services/Fire Fighting Services/Header";
import SecendSection from "../Component/Services/Fire Fighting Services/SecendSection";
import ServicesInfo from "../Component/Services/Fire Fighting Services/ServicesInfo";
import QuickContact from "../Component/Services/QuickContact"

function FireFightingServices() {
  return (
    <div>
      <Header />
      <SecendSection />
      <ServicesInfo />
      <QuickContact />
    </div>
  );
}

export default FireFightingServices;
